export default {"src":"/_next/static/media/Back and Neck Pain.b32edd21.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};